import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Sirve si recién estoy arrancando como docente de Física o Ciencias Naturales?',
    a: 'Sí. El Tomo 1 empieza desde los fundamentos absolutos del átomo y cada tomo tiene una lógica didáctica progresiva. El sistema está pensado tanto para docentes que inician como para los que ya tienen años de experiencia y quieren profesionalizar su material con el contexto nuclear argentino actualizado al 2026.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Apenas confirmado el pago recibís un link de descarga directa. Acceso inmediato en menos de 5 minutos. Los PDFs son de alta calidad y están optimizados para leer en pantalla o imprimir.'
  }, {
    q: '¿El Upsell Premium es necesario?',
    a: 'Depende de tu objetivo. Si solo querés mejorar tus clases con material técnico, actividades, evaluaciones y casos de estudio listos, el Megapack base es suficiente y muy completo. Si además querés enseñar las tecnologías más avanzadas de 2026 (SMR, IA y fusión nuclear), posicionarte como docente de vanguardia y tener el material que ningún libro de texto tiene todavía, el Upsell Premium es la mejor inversión de tu carrera docente.'
  }, {
    q: '¿Cuánto tiempo lleva implementarlo?',
    a: 'El primer día podés tener una actividad del Bono 1 aplicada en el aula y una evaluación del Bono 4 lista para usar. Los tomos los podés leer a tu ritmo. La mayoría de los docentes implementa cambios visibles en la primera semana.'
  }, {
    q: '¿La garantía es real?',
    a: 'Sí. Escribís a nuestro contacto dentro de los 7 días y te devolvemos el 100% sin preguntas. Tenemos menos del 1% de devoluciones porque el material cumple lo que promete.'
  }, {
    q: '¿Aplica para cualquier nivel educativo?',
    a: 'Sí. Secundario general, secundario técnico, terciario o formación docente. Todo el contenido tiene tres niveles de profundidad claramente indicados con actividades y ejercicios diferenciados. También aplica para docentes de Historia, Geografía y Formación Ciudadana que quieren incorporar el programa nuclear argentino como contenido de soberanía tecnológica.'
  }, {
    q: '¿Necesito conocimientos avanzados de física nuclear para usarlo?',
    a: 'No. Cada tomo empieza desde lo conceptual con analogías claras y avanza con rigor técnico graduado. Si sos docente de Ciencias Naturales sin especialización en física nuclear, este material fue pensado especialmente para vos.'
  }, {
    q: '¿Puedo enseñar sobre el CAREM-25 si no sé qué es?',
    a: 'Sí, y vas a sorprender a tus alumnos. El Tomo 6 y el Caso 8 del Bono 2 te explican el CAREM-25 con tal profundidad que vas a poder presentarlo como lo que es: el primer reactor modular pequeño del mundo en construcción avanzada con diseño 100% argentino.'
  }, {
    q: '¿Por qué la energía nuclear importa si Argentina no tiene muchas centrales?',
    a: 'Argentina tiene más centrales nucleares que el 90% de los países del mundo. Tiene tres centrales operativas desde 1974, exporta reactores a Australia, Argelia y Egipto, produce los radioisótopos médicos para todo el continente y está construyendo el primer SMR del mundo. El problema no es que Argentina no sea relevante en el mundo nuclear. El problema es que casi ningún docente lo sabe todavía.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-surface" data-id="element-76">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-77">
        <h2 className="text-3xl font-extrabold text-center text-white mb-12" data-id="element-78">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-79">
          {faqs.map((faq, i) => <div key={i} className="border border-surface rounded-2xl overflow-hidden bg-base/60" data-id="element-80">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-neon" aria-expanded={openIndex === i} data-id="element-81">
                <span className="font-bold text-white pr-4" data-id="element-82">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-muted transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-83" />
              </button>

              <AnimatePresence data-id="element-84">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-85">
                    <div className="px-6 pb-5 text-muted leading-relaxed border-t border-surface pt-3" data-id="element-86">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}